import { constantsTypes } from "../reduxConstants";

const initialValue = { value: 0 };

export const bankofferViewMode = (state = initialValue, action) => {
  switch (action.type) {
    case constantsTypes.BANK_OFFER_ID:
      return { ...state, value: action.payload };
    default:
      return state;
  }
};
